import React from "react"
import styled, { css } from "styled-components"
import { media } from "../../styles/media"

const StyledTitleContainer = styled.div`
  width: 70%;
  position: absolute;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  text-shadow: 0px 0px 5px grey;
`

const StyledTitle = styled.h2`
  color: #fff;
  font-size: 1.62em;
  padding-bottom: 0.62em;
  text-align: center;
  ${() =>
    media.sp(css`
      font-size: 1.32rem;
    `)}
`
const StyledSubTitle = styled.p`
  color: #fff;
  padding: 0.32em 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  line-height: 1.2;
  ${() =>
    media.sp(css`
      font-size: 0.8rem;
    `)}
`
export default function Title({ title, subTitle = [] }) {
  return (
    <StyledTitleContainer>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubTitle>
        {subTitle.map((sub, i) => (
          <span key={i}>{sub}</span>
        ))}
      </StyledSubTitle>
    </StyledTitleContainer>
  )
}
